(() => {
  const MOBILE_QUERY = '(max-width: 749px)';
  const ROOT_SELECTOR = '.ns-site-header header-drawer #Details-menu-drawer-container';

  const isMobile = () => window.matchMedia(MOBILE_QUERY).matches;

  function flattenMobileMenu(rootDetails) {
    if (!rootDetails || !isMobile() || !rootDetails.hasAttribute('open')) return;

    const navigation = rootDetails.querySelector('.menu-drawer__navigation');
    const topMenu = navigation?.querySelector(':scope > .menu-drawer__menu');
    if (!topMenu) return;

    topMenu.classList.remove('submenu-open', 'hy-mobile-branch-active');

    Array.from(topMenu.children).forEach((item) => {
      item.classList.remove('hy-mobile-active-item');

      const details = item.querySelector(':scope > details');
      if (!details) return;

      const summary = details.querySelector(':scope > summary');
      const submenu = summary?.nextElementSibling;

      details.setAttribute('open', '');
      details.classList.remove('menu-opening', 'hy-mobile-submenu-open');
      details.classList.add('hy-mobile-flat-section');
      summary?.setAttribute('aria-expanded', 'true');
      submenu?.setAttribute('aria-hidden', 'false');
    });

    rootDetails.querySelector('.menu-drawer')?.classList.add('hy-mobile-flat-drawer');
  }

  function resetDesktopState(rootDetails) {
    if (!rootDetails || isMobile()) return;

    rootDetails.querySelectorAll('.hy-mobile-flat-section').forEach((details) => {
      details.classList.remove('hy-mobile-flat-section');
    });

    rootDetails.querySelector('.menu-drawer')?.classList.remove('hy-mobile-flat-drawer');
  }

  function observeRoot(rootDetails) {
    if (!rootDetails || rootDetails.dataset.hyFlatMenuObserved === 'true') return;
    rootDetails.dataset.hyFlatMenuObserved = 'true';

    const observer = new MutationObserver(() => {
      if (rootDetails.hasAttribute('open')) {
        requestAnimationFrame(() => flattenMobileMenu(rootDetails));
      }
    });

    observer.observe(rootDetails, {
      attributes: true,
      attributeFilter: ['open'],
    });
  }

  function initialize() {
    document.querySelectorAll(ROOT_SELECTOR).forEach((rootDetails) => {
      observeRoot(rootDetails);
      flattenMobileMenu(rootDetails);
    });
  }

  document.addEventListener(
    'click',
    (event) => {
      if (!isMobile()) return;

      const rootSummary = event.target.closest(`${ROOT_SELECTOR} > summary`);
      if (!rootSummary) return;

      const rootDetails = rootSummary.parentElement;
      window.setTimeout(() => flattenMobileMenu(rootDetails), 0);
    },
    true
  );

  window.addEventListener('resize', () => {
    document.querySelectorAll(ROOT_SELECTOR).forEach((rootDetails) => {
      if (isMobile()) {
        flattenMobileMenu(rootDetails);
      } else {
        resetDesktopState(rootDetails);
      }
    });
  });

  document.addEventListener('DOMContentLoaded', initialize);
  document.addEventListener('shopify:section:load', initialize);

  if (document.readyState !== 'loading') initialize();
})();